import { createStore, applyMiddleware } from 'redux'; 
import thunk from 'redux-thunk';  
import reducers from './reducer/reducer';

let createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

let store = createStoreWithMiddleware(reducers);

export default store;



// WEBPACK FOOTER //
// ./src/ReduxStore.js